import React, { useCallback } from "react";
import useFetchData from "../../hooks/useFetchData";
import FieldSelectorFromPopup from "../BuilderComponents/FieldSelectorFromPopup";
import SingleJobPopup from "../BuilderComponents/JobConfigration/SingleJobPopup";
import Label from "../FormComponents/Label";
import { ImageSelectorFromRepo } from "./EditImageConfig";
import Input from "../FormComponents/Input";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import { InlineColorMasterdataSelection } from "./EditField";

const EditBlock = ({ editElementData, setEditElementData, tableId, tableType, jobPlaces, device }) => {
  const handleChange = useCallback(
    (key, value) => setEditElementData((prevData) => ({ ...prevData, [key]: value })),
    [setEditElementData]
  );
  return (
    <div className="builder_form gap_3">
      <ImageSelectorFromRepo
        selected={editElementData.repo_source || ""}
        onChange={(repo) => handleChange("repo_source", repo.id)}
        label="Select Background Image"
      />
      <div className="flex_column gap_2">
        <Label>Select Image Field</Label>
        {tableId ? (
          <FieldSelectorFromPopup
            tableId={tableId}
            tableType={tableType}
            onSelect={(field) => handleChange("bg_image_field", field)}
            fieldId={editElementData.bg_image_field?.id || ""}
          />
        ) : (
          <span>Table not found</span>
        )}
      </div>
      <InlineColorMasterdataSelection
        colorConfigType={editElementData?.color_config_type}
        handleEditElementData={handleChange}
        colorMasterData={editElementData?.color_master_data || ""}
        colorIf={editElementData?.colorif}
        colorIfField={editElementData?.colorif_field}
        tableId={tableId}
        tableType={tableType}
      />
      <VisibilityConditions
        visibility={editElementData.visibility || {}}
        onChange={(v) => handleChange("visibility", v)}
        tableId={tableId}
        tableType={tableType}
      />
      <AssignJob
        jobPlaces={jobPlaces}
        config={editElementData.on_block_click || null}
        onChange={(job) => handleChange("on_block_click", job)}
        tableId={tableId}
        tableType={tableType}
        device={device}
      />
      <Input
        type="checkbox"
        checked={editElementData.as_card}
        label="Display as Card"
        onChange={(e) => handleChange("as_card", e.target.checked)}
      />
    </div>
  );
};

const AssignJob = ({ jobPlaces, config, onChange, tableId, device, tableType }) => {
  const { data, error, loading } = useFetchData(`/jobs/filter/?places=${jobPlaces}&elements=button`);

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
      <SingleJobPopup
        config={config}
        allJobs={data}
        smId={tableId}
        device={device}
        onChange={onChange}
        label="On Click Job"
        type={tableType}
      />
    </>
  );
};

const VisibilityConditions = ({ visibility, onChange, tableId, tableType }) => {
  return (
    <>
      <VisibilityRules
        rules={visibility.rules || []}
        onChange={(v) => onChange({ ...visibility, rules: v, operator: "AND" })}
        tableId={tableId}
        tableType={tableType}
      />
    </>
  );
};

const VisibilityRules = ({ rules = [], onChange, tableId, tableType }) => {
  //NOTE: For now we consider only one rule in future if requ. we will add more rule
  const rule = rules?.[0] || {};

  const conditionOptions = [
    { id: "is_filled", name: "Has Value" },
    { id: "is_not_filled", name: "Is Empty" },
    { id: "equals", name: "Equals" },
    { id: "not_equals", name: "Not Equals" },
    { id: "contains", name: "Contains" },
    { id: "not_contains", name: "Does Not Contain" }
  ];

  const handleFieldSelect = (field) => {
    let updatedRules = [];
    if (field.id) {
      updatedRules = [
        {
          ...rule,
          field_id: field.id,
          condition: rule.condition || "is_filled",
          value: rule.condition === "is_filled" ? "" : rule.value || ""
        }
      ];
    }
    onChange(updatedRules);
  };

  const handleConditionChange = (option) => {
    const newCondition = option.id;
    const updatedRules = [
      {
        ...rule,
        condition: newCondition,
        value: newCondition === "is_filled" || newCondition === "is_not_filled" ? "" : rule.value || ""
      }
    ];
    onChange(updatedRules);
  };

  const handleValueChange = (e) => {
    const updatedRules = [
      {
        ...rule,
        value: e.target.value
      }
    ];
    onChange(updatedRules);
  };

  const isValueDisabled = rule.condition === "is_filled" || rule.condition === "is_not_filled" || !rule.field_id;

  return (
    <div className="builder_form gap_1">
      <Label>Visibility Rules</Label>
      <div className="flex_row gap_2 align_end">
        <div className="flex_grow flex flex_column gap_2" style={{ minWidth: "150px" }}>
          <label className="builder_label">Field</label>
          <FieldSelectorFromPopup
            tableId={tableId}
            tableType={tableType}
            onSelect={handleFieldSelect}
            fieldId={rule.field_id || ""}
            label="Field"
          />
        </div>

        {rule.field_id && (
          <>
            <div style={{ minWidth: "150px" }}>
              <SingleSelectBox
                options={conditionOptions}
                valueKey="id"
                labelKey="name"
                selectedData={rule.condition || "is_filled"}
                onChange={handleConditionChange}
                label="Condition"
              />
            </div>

            <div className="flex_grow">
              <Input
                type="text"
                label="Value"
                value={rule.value || ""}
                onChange={handleValueChange}
                disabled={isValueDisabled}
                placeholder={isValueDisabled ? "Not applicable" : "Enter value"}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EditBlock;
export { VisibilityConditions };
